export function sortIntAsc(a: number | string, b: number | string) {
  return (a as number) - (b as number);
}

export function sortIntDesc(a: number | string, b: number | string) {
  return (b as number) - (a as number);
}
